import _ from "lodash";
import CONSTANTS from "./../common/constants";

class ServiceHandler {
	static handle(response, successTitle, successMessage) {
		const status = response.status || response.statusCode;
		if (
			status === CONSTANTS.STATUS_CODE.OK ||
			status === CONSTANTS.STATUS_CODE.CREATED ||
			status === CONSTANTS.STATUS_CODE.ACCEPTED ||
			status === CONSTANTS.STATUS_CODE.NO_CONTENT
		) {
			return {
				status,
				title: successTitle,
				message: successMessage
			};
		} else {
			throw response;
		}
	}

	static handleCatch(e) {
		throw {
			status: _.get(e, `status`, 500),
			title: `Error`,
			message: _.get(e, `message`, _.get(e, `statusText`, `Something went wrong processing the request.`))
		};
	}
}
export default ServiceHandler;
